import { createSlice } from "@reduxjs/toolkit";
import { Constants } from "@constants/Constants";

const initialState = {
  loading: false,
  filtersError: false,
  allInitialValue: {
    businessFunctions: [],
    subFunctions: [],
    industries: [],
    subIndustries: [],
    implementationGuide: [],
    businessValues: [],
    businessValueRatings: [],
    feasibilityRatings: [],
    useCaseCategories: [],
    zodiacCategory: [],
  },
  selectedValues: {
    page: 0,
    size: 20,
    token: "",
    searchType: Constants.SEARCH_TYPE.ALL,
    businessFunctions: [],
    subFunctions: [],
    industries: [],
    subIndustries: [],
    implementationGuide: [],
    businessValues: [],
    businessValueRatings: [],
    feasibilityRatings: [],
    useCaseCategories: [],
    zodiacCategory: [],
    defaultFilter: null,
    sortingValue: Constants.USE_CASE_SORTING.DEFUALT_OPTION,
  },
};

export const filterSlice = createSlice({
  name: "filter",
  initialState,
  reducers: {
    setInitialState: (state, action) => {
      state.loading = false;
      state.allInitialValue.businessFunctions = action.payload.businessFunction.map(item => item.value && item);
      state.allInitialValue.subFunctions = action.payload.subFunction.map(item => item.value && item);
      state.allInitialValue.industries = action.payload.industry.map(item => item.value && item);
      state.allInitialValue.subIndustries = action.payload.subIndustry.map(item => item.value && item);
      state.allInitialValue.implementationGuide = action.payload?.implementationGuide?.map(item => item.value && item);
      state.allInitialValue.businessValues = action.payload.businessValues.map(item => item.value && item);
      state.allInitialValue.businessValueRatings = action.payload.businessValueScore.map(item => item.value && item);
      state.allInitialValue.feasibilityRatings = action.payload.feasibilityScore.map(item => item.value && item);
      state.allInitialValue.useCaseCategories = action.payload.useCaseCategory.map(item => item.value && item);
      state.allInitialValue.zodiacCategory = action.payload.zodiacCategory.map(item => item.value && item);

      state.selectedValues.businessFunctions = state.selectedValues.businessFunctions.filter(
        (businessFunction) =>
          action.payload.businessFunction.find(
            (item) => item.value === businessFunction && item.isSelected
          )
      );

      state.selectedValues.subFunctions = state.selectedValues.subFunctions.filter(
        (subFunction) =>
          action.payload.subFunction.find(
            (item) => item.value === subFunction && item.isSelected
          )
      );

      state.selectedValues.industries = state.selectedValues.industries.filter(
        (industry) =>
          action.payload.industry.find(
            (item) => item.value === industry && item.isSelected
          )
      );

      state.selectedValues.subIndustries = state.selectedValues.subIndustries.filter(
        (subIndustry) =>
          action.payload.subIndustry.find(
            (item) => item.value === subIndustry && item.isSelected
          )
      );

      state.selectedValues.implementationGuide = state.selectedValues?.implementationGuide?.filter(
        (implementationGuide) =>
          action.payload.implementationGuide.find(
            (item) => item.value === implementationGuide && item.isSelected
          )
      );

      state.selectedValues.businessValues = state.selectedValues.businessValues.filter(
        (businessValues) =>
          action.payload.businessValues.find(
            (item) => item.value === businessValues && item.isSelected
          )
      );

      state.selectedValues.businessValueRatings = state.selectedValues.businessValueRatings.filter(
        (businessValueScore) =>
          action.payload.businessValueScore.find(
            (item) => item.value === businessValueScore && item.isSelected
          )
      );

      state.selectedValues.feasibilityRatings = state.selectedValues.feasibilityRatings.filter(
        (feasibilityScore) =>
          action.payload.feasibilityScore.find(
            (item) => item.value === feasibilityScore && item.isSelected
          )
      );

      state.selectedValues.useCaseCategories = state.selectedValues.useCaseCategories.filter(
        (useCaseCategory) =>
          action.payload.useCaseCategory.find(
            (item) => item.value === useCaseCategory && item.isSelected
          )
      );

      state.selectedValues.zodiacCategory = state.selectedValues.zodiacCategory.filter(
        (zodiacCategory) =>
          action.payload.zodiacCategory.find(
            (item) => item.value === zodiacCategory && item.isSelected
          )
      );
    },
    updateFilter: (state, action) => {
      state.loading = true;
      state.selectedValues = action.payload;
    },
    startLoading: (state) => {
      state.loading = true;
      state.filtersError = false;
    },
    filterFailure: (state) => {
      state.filtersError = true;
      state.loading = false;
    },
  },
});

const { actions, reducer } = filterSlice;
export const { setInitialState, updateFilter, startLoading, filterFailure } = actions;

export default reducer;
